export default "__VITE_ASSET__ByQKYPzO__"